<app-modal-base
  [title]="dialogTitle"
  [loading]="formSubmitting"
  [isDisabled]="form.invalid"
  [hasSubmit]="!data.visitFeedback"
  [cancelType]="data.visitFeedback ? 'CLOSE' : 'CANCEL'"
  (onSubmitEvent)="onSubmit()"
>
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <form [formGroup]="form" class="form">
      <div id="top-feedback">
        <!-- Rapport de visite -->
        <div class="special-card sc-rapport">
          <div class="sc-title">Rapport de visite</div>
          <div class="sc-content">
            <p class="sc-text">
              Rapport de visite de {{ sharingTargetUser }} pour le bien
              {{ data.prop.name }} situé à l'adresse {{ propAddress }}
            </p>
          </div>
        </div>
        <!-- visite date -->
        <div class="special-card sc-sm">
          <div class="sc-title">Date</div>
          <div class="sc-content">
            <app-input
              type="date"
              label="Date de la visite"
              [formControl]="form_visitDate"
            ></app-input>
          </div>
        </div>
        <!-- saisi par -->
        @if (data?.visitFeedback?.dateCreate) {
        <div class="special-card sc-sm">
          <div class="sc-title">Saisi par</div>
          <div class="sc-content">
            <p class="sc-text">{{ feedbackUser }}</p>
            <p class="sc-text">
              le <i>{{ data?.visitFeedback?.dateCreate | dateFormat }}</i
              >.
            </p>
          </div>
        </div>
        }

        <!-- prix -->
        <div class="special-card sc-sm sc-prix">
          <div class="sc-title">Prix de mise en vente</div>
          <div class="sc-content">
            <p class="sc-hihlight">
              {{ data.prop.onGoingSelling.price | toNumber }}
            </p>
          </div>
        </div>
      </div>

      <!-- review -->
      <h2 class="modal-subtitle">Vos impressions</h2>
      <div class="wrap-review" formGroupName="review">
        @for (review of reviews; track $index) {
        <div class="review" [class.review-disabled]="form_pros.disabled">
          <div class="review-left">
            <p class="review-title">{{ review.name }}</p>
            <p class="review-resume">
              {{
                form_review.get(review.formControlName)?.value | reviewResume
              }}
            </p>
          </div>
          <!-- stars -->
          <div class="review-right">
            <mat-radio-group
              [formControlName]="review.formControlName"
              [class.no-value]="!form_review.get(review.formControlName)?.value"
              color="primary"
              required
            >
              @for (item of NB_NOTE; track $index) {
              <mat-radio-button [value]="$index + 1" [labelPosition]="'before'">
                <mat-icon
                  matRipple
                  (click)="animate($event)"
                  (animationend)="resetAnimation($event)"
                  >grade</mat-icon
                >
              </mat-radio-button>
              }
            </mat-radio-group>
          </div>
        </div>
        }
      </div>

      <h2 class="modal-subtitle">Vos commmentaires</h2>
      <div class="form-group row">
        <mat-form-field class="col-md-6">
          <mat-label>Les points positifs</mat-label>
          <textarea [formControl]="form_pros" matInput required></textarea>
          <mat-error>
            <span *ngIf="form_pros.hasError('required')"
              >Champ obligatoire</span
            >
          </mat-error>
        </mat-form-field>

        <mat-form-field class="col-md-6">
          <mat-label>Les points négatifs</mat-label>
          <textarea [formControl]="form_cons" matInput required></textarea>
          <mat-error>
            <span *ngIf="form_pros.hasError('required')"
              >Champ obligatoire</span
            >
          </mat-error>
        </mat-form-field>

        <mat-form-field class="col-md-6">
          <mat-label>Autres</mat-label>
          <textarea [formControl]="form_others" matInput></textarea>
        </mat-form-field>

        <mat-form-field class="col-md-6">
          <mat-label>A quel prix estimeriez-vous ce bien ?</mat-label>
          <textarea [formControl]="form_estimate" matInput></textarea>
        </mat-form-field>

        <mat-form-field class="col-md-6">
          <mat-label>Des commentaires sur la visite ?</mat-label>
          <textarea [formControl]="form_comments" matInput></textarea>
        </mat-form-field>
      </div>

      <h2 class="modal-subtitle">Souhaitez-vous donner suite ?</h2>
      <div class="form-group">
        <mat-radio-group
          formControlName="goFurther"
          color="primary"
          labelPosition="after"
        >
          <mat-radio-button [value]="true"
            >Oui, ce bien m'intéresse</mat-radio-button
          >
          <mat-radio-button [value]="false"
            >Non, il ne me convient pas</mat-radio-button
          >
        </mat-radio-group>
      </div>
    </form>
  </div>
</ng-template>
